import {combineLatest} from 'rxjs';
import {filter, map, shareReplay, startWith, throttleTime} from 'rxjs/operators';
import {wwData$} from './worker-data';
import {contract$} from './contract';
import {bookTickSizeEp$, fixationBook$} from './book';
import Msg = ww.Msg;

export const contractMarketCache$ = wwData$.pipe(
  filter((o: Msg<any>) => o.type === 'market24h-contract'),
  map((o: Msg<any>): Map<string, ContractMarket> => o.data),
  filter(Boolean),
  startWith(new Map<string, ContractMarket>()),
  shareReplay(1)
);

export const market$ = combineLatest([contract$, contractMarketCache$]).pipe(
  map(([contract, contractMarketCache]) => contractMarketCache.get(contract.symbol)),
  filter(Boolean),
  startWith(createInitMarket()),
  shareReplay(1)
);

export const curBookPrice$ = combineLatest([contract$, market$, bookTickSizeEp$, fixationBook$]).pipe(
  throttleTime(300),
  map(([contract, market, bookTickSizeEp, book]) => {
    if (contract.symbol === book.symbol && contract.tickSizeEp === bookTickSizeEp) {
      return {
        symbol: contract.symbol,
        ask1Ep: book.ask1Ep,
        bid1Ep: book.bid1Ep,
      };
    }
    if (contract.symbol === market.symbol) {
      return {
        symbol: contract.symbol,
        ask1Ep: market.askEp,
        bid1Ep: market.bidEp,
      };
    }
    return null;
  }),
  filter(Boolean),
  startWith({ask1Ep: 0, bid1Ep: 0, symbol: ''}),
  shareReplay(1)
);

function createInitMarket(): ContractMarket {
  return {
    type: 'Perpetual',
    symbol: 'BTCUSD',
    symbolV2: 'BTCUSD',
    status: 'Listed',
    pairName: 'BTCUSD',
    displaySymbol: 'BTCUSD',
    baseCurrency: 'BTC',
    openEp: 0,
    open: '--',
    closeEp: 0,
    close: '--',
    highEp: 0,
    high: '--',
    lowEp: 0,
    low: '--',
    indexPriceEp: 0,
    indexPrice: '--',
    markPriceEp: 0,
    markPrice: '--',
    turnoverEv: 0,
    turnoverStr: '--',
    turnoverWU: '-- ' + 'BTC',
    turnoverWithUSDRaw: 0,
    isCheapCopyToken: false,
    openInterest: 0,
    openInterestStr: '--',
    volume24hStr: '--',
    fundingRate: 0,
    fundingRateStr: '--',
    predFundingRate: 0,
    predFundingRateStr: '--',
    change24hEp: 0,
    change24hStr: '--',
    changePercent: 0,
    changePercentStr: '--%',
    combinationTurnoverEv: 0,
    contractSide: 0,
    volume24hWithUSD: '--',
    turnoverWithUSD: '--',
    klineData: [],
    isNew: false,
    volume: 0,
    turnover: '--',
    bidEp: 0,
    bid: '--',
    askEp: 0,
    ask: '--',
  };
}
